import { __decorate } from "tslib";
import { action, observable, runInAction } from 'mobx';
import moment from 'moment';
import defaultTo from 'lodash/defaultTo';
import defaultLocale from './locale';
import defaultSupports from './supports';
import { normalizeLanguage } from '../utils';
import { mobxGet } from '../mobx-helper';
function setMomentLocale(locale) {
    moment.locale(normalizeLanguage(locale ? locale.lang : defaultLocale.lang));
}
export class LocaleContext {
    constructor() {
        runInAction(() => {
            this.locale = defaultLocale;
            this.supports = defaultSupports;
        });
    }
    setLocale(locale) {
        setMomentLocale(locale);
        this.locale = locale;
    }
    setNumberFormatLanguage(numberFormatLanguage) {
        this.numberFormatLanguage = numberFormatLanguage;
    }
    setSupports(supports) {
        this.supports = supports;
    }
    getCmp(component) {
        return mobxGet(this.locale, component);
    }
    get(component, key, defaults) {
        const componentString = String(component);
        const cmp = mobxGet(this.locale, componentString) || (defaults && mobxGet(defaults, componentString));
        if (key) {
            return defaultTo(cmp && mobxGet(cmp, String(key)), `${componentString}.${key}`);
        }
        return componentString;
    }
}
__decorate([
    observable
], LocaleContext.prototype, "locale", void 0);
__decorate([
    observable
], LocaleContext.prototype, "numberFormatLanguage", void 0);
__decorate([
    observable
], LocaleContext.prototype, "supports", void 0);
__decorate([
    action
], LocaleContext.prototype, "setLocale", null);
__decorate([
    action
], LocaleContext.prototype, "setNumberFormatLanguage", null);
__decorate([
    action
], LocaleContext.prototype, "setSupports", null);
export default new LocaleContext();
